import { PaginationProps } from '@/types/admin_types';
import { Pagination } from '@mui/material'

type Props = {
  data: PaginationProps;
  setPage: (page: number) => void;
}

export default function PaginationEl({ data, setPage }: Props) {

  const handleChangePage = (_event: any, page: number) => {
    setPage(page)
  }


  return (
    <div  className='flex items-center justify-center p-4'>
      <Pagination
        count={data.last_page} 
        shape="rounded"
        color="primary" 
        variant='outlined'
        page={data?.current_page}
        onChange={handleChangePage}
      />
    </div>
  )
}
